import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

const state = {
	content: '',
    products: [],
    categories: [],
    onCategoryView: false,
    lastCategoryView: '',
    onProductView: false,
    isInstalled: false,
    isBootstraped: false,
    isLoading: false
}

const mutations = {

	BOOTSTRAP ( state, payload ) {
		state.content = payload.content
		state.isBootstraped = true
	},
	UPDATE ( state, payload ) {
		state.content = payload.content
		state.isLoading = false
	},
	FETCH_CATEGORIES ( state, payload ) {
		state.categories = payload.categories
	},
	FETCH_PRODUCTS ( state, payload ) {
		state.products = payload.products
	},
    PRODUCTS_UPDATE_ALL ( state, payload ) {
		state.products = payload
  	},
  	ON_CATEGORY_VIEW ( state, payload ) {
		state.onCategoryView = true
	},
	LAST_CATEGORY_VIEW ( state, payload ) {
		state.lastCategoryView = payload.label
	},
    ON_PRODUCT_VIEW ( state, payload ) {
		state.onProductView = true
	},
	ON_NEUTRAL_PAGE ( state, payload ) {
		state.onCategoryView = false
		state.onProductView = false
	},
	LOAD ( state, payload ) {
		state.isLoading = true
	},
	UNLOAD ( state, payload ) {
		state.isLoading = false
	},
	INSTALLED ( state, payload ) {
		state.isInstalled = true
	}
}

export default new Vuex.Store({
	actions,
	getters,
	state,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js